import { gql } from '@apollo/client';

export const DELETE_PATIENT_ADDRESS = gql`
  mutation DeletePatientAddress($data: DeletePatientAddressInput!) {
    deletePatientAddress(data: $data)
  }
`;
